var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9211 17.0438V19.8063L16.9711 21.6032V32.3438L7.88047 26.7469V13.4875L5.54297 12.1125V28.0063L19.3055 36.4782V20.2188L13.9211 17.0438Z",
    fill: "#171717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6934 20.2188V26.2719L22.8371 25.0188V21.4407L32.2309 15.9094V26.7563L20.6934 33.9V36.4782L34.4559 28.0063V12.1125L20.6934 20.2188Z",
    fill: "#171717"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0035 14.6813L20.0004 16.4501L10.8129 11.0407L20.0004 6.0876L31.466 12.2657L33.741 10.9282L20.0004 3.52197L6.25977 10.9282L20.0004 19.0188L25.1598 15.9813L23.0035 14.6813Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.d8d649f3cde9d0fbfb4e683584428865.svg";
export { ForwardRef as ReactComponent };